import styled from 'styled-components';
import { Box } from '../Box/Box';

export const StyledDropzone = styled(Box)<{ isDragActive: boolean }>(({ theme, isDragActive }) => ({
  border: `1px dashed ${theme.colors.neutral[isDragActive ? '500' : '300']}`,
  background: isDragActive ? theme.colors.neutral['100'] : theme.colors.bg,
  padding: '64px 24px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  borderRadius: theme.radii.medium,
  transition: `background ${theme.transitions.normal}, border ${theme.transitions.normal}`,
}));
